import React, { useState } from "react";
import News from "../assets/news.png";
import ParticleBackground from "../components/ParticleBackground";
import NewsModal from "../components/NewsModal";

const NewsEvents = () => {
  const [selectedNews, setSelectedNews] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [playingVideoId, setPlayingVideoId] = useState(null);

  const newsData = [
    {
      id: 1,
      title:
        "Hunarmand Punjab Brainathon Competition Winners Award Ceremony | Punjab Skill Development",
      videoUrl: "https://www.youtube.com/embed/9AnOeOdlG1c",
      fullDescription: `Hunarmand Punjab successfully organized the Brainathon Competition and awarded the winners in an official award ceremony held with the presence of distinguished dignitaries.

The ceremony was graced by Chief Guests including the Speaker Punjab Assembly Malik Ahmad Khan, and Education Minister Rana Sikandar Hayat.
This Brainathon Competition was conducted under the Skills Development and Youth Empowerment Program of Punjab, aimed at encouraging innovation, critical thinking, and problem-solving skills among the youth of Punjab.

The presence of senior leadership from the Punjab Government reflects strong support for skill-based education and innovation initiatives.
Hunarmand Punjab remains committed to empowering youth by providing platforms that promote talent, creativity, and professional growth.
This award ceremony highlights the vision of Hunarmand Punjab to build a skilled, competitive, and self-reliant generation for the future of Pakistan.`,
    },
    {
      id: 2,
      title:
        "Empowering Punjab’s Youth: Rana Sikander Hayat on the Vision of Hunarmand Punjab | Skill Revolution",
      videoUrl: "https://www.youtube.com/embed/qjPnPPuF-wo",
      fullDescription: `𝐑𝐞𝐯𝐨𝐥𝐮𝐭𝐢𝐨𝐧𝐢𝐳𝐢𝐧𝐠 𝐄𝐝𝐮𝐜𝐚𝐭𝐢𝐨𝐧 𝐭𝐡𝐫𝐨𝐮𝐠𝐡 𝐒𝐤𝐢𝐥𝐥 𝐃𝐞𝐯𝐞𝐥𝐨𝐩𝐦𝐞𝐧𝐭.🎓

We are honored to present a special message from 𝐑𝐚𝐧𝐚 𝐒𝐢𝐤𝐚𝐧𝐝𝐞𝐫 𝐇𝐚𝐲𝐚𝐭, 𝐏𝐫ο𝐯𝐢𝐧𝐜𝐢𝐚𝐥 𝐌𝐢𝐧𝐢𝐬𝐭𝐞𝐫 𝐟𝐨𝐫 𝐒𝐜𝐡𝐨𝐨𝐥 𝐄𝐝𝐮𝐜𝐚𝐭𝐢𝐨𝐧, 𝐏𝐮𝐧𝐣𝐚𝐛.

As a leader dedicated to the progress of our youth, the Minister highlights the government’s commitment to integrating modern skills with traditional education. Through the 𝐇𝐮𝐧𝐚𝐫𝐦𝐚𝐧𝐝 𝐏ｕ𝐧𝐣а𝐛 initiative, we are not just teaching; we are building a workforce capable of leading the global digital economy.

Watch as he outlines the roadmap for a more prosperous, skilled, and self-reliant Punjab.`,
    },
    {
      id: 3,
      title:
        "Malik Ahmad Khan Full Speech at Hunarmand Punjab Program | Education & AI Revolution",
      videoUrl: "https://www.youtube.com/embed/JLPx3ZeM9Xc",
      fullDescription: `Inspiring address by the Acting 𝐆𝐨𝐯𝐞𝐫𝐧𝐨𝐫 𝐨𝐟 𝐏𝐮𝐧𝐣𝐚𝐛, 𝐌𝐚𝐥𝐢𝐤 𝐌𝐮𝐡𝐚𝐦𝐦𝐚𝐝 𝐀𝐡𝐦𝐚𝐝 𝐊𝐡𝐚𝐧, at the 𝐇ｕ𝐧𝐚𝐫𝐦ａ𝐧𝐝 𝐏ｕｎｊａ𝐛 𝐏ｒｏ𝐠ｒａｍ launch/convocation held at 𝐏ｕｎｊａｂ 𝐔ｎｉｖｅｒｓｉｔ𝐲 (𝐏𝐔). This speech outlines the government's strategic roadmap to empower the youth through high-tech skills and a modern educational curriculum.

𝐓𝐡𝐞 𝐇ｕｎａ𝐫ｍａｎ𝐝 𝐏ｕｎｊａ𝐛 𝐕𝐢𝐬𝐢ｏ𝐧: Why this program is the backbone of economic empowerment for the students of Punjab.

𝟑𝐱 𝐈𝐧𝐜𝐫𝐞𝐚𝐬𝐞 𝐢𝐧 𝐄𝐝𝐮𝐜ａ𝐭𝐢ｏ𝐧 𝐁𝐮𝐝𝐠𝐞𝐭: Malik Ahmad Khan explains how CM Maryam Nawaz Sharif has prioritized education like never before.

𝐀𝐈 𝐢𝐧 𝟔𝟎,𝟎𝟎𝟎 𝐒𝐜𝐡𝐨𝐨𝐥𝐬: A visionary plan to introduce Artificial Intelligence and Computing at the primary level in 60,000 government schools.

𝐋𝐞𝐚𝐝𝐞𝐫𝐬𝐡𝐢𝐩 𝐄𝐱ｃ𝐞𝐥ｌ𝐞ｎｃｅ: A tribute to Rana Sikander Hayat (Minister for Education) for his dynamic role in the successful execution of the Hunarmand initiative.`,
    },
    {
      id: 4,
      title:
        "𝐂𝐨𝐥𝐥𝐚𝐛𝐨𝐫𝐚𝐭𝐢𝐨𝐧: 𝐇𝐮𝐧𝐚𝐫𝐦𝐚𝐧𝐝 𝐏𝐮𝐧𝐣𝐚𝐛 & 𝐏𝐮𝐧𝐣𝐚𝐛 𝐔𝐧𝐢𝐯𝐞𝐫𝐬𝐢𝐭𝐲 𝐌𝐎𝐔 | 𝐕𝐂 𝐏𝐔 𝐌𝐮𝐡𝐚𝐦𝐦𝐚𝐝 𝐀𝐥𝐢 𝐀𝐝𝐝𝐫𝐞𝐬𝐬",
      videoUrl: "https://www.youtube.com/embed/MxI2z5t-48A",
      fullDescription: `In this exclusive interview, 𝐏ｒｏ𝐟. 𝐃𝐫. 𝐌𝐮𝐡𝐚𝐦𝐦𝐚𝐝 𝐀𝐥𝐢, 𝐕ｉｃｅ-𝐂ｈａｎｃｅｌｌ𝐨𝐫 𝐨𝐟 𝐭𝐡𝐞 𝐔ｎｉｖｅｒｓ𝐢ｔ𝐲 𝐨𝐟 𝐭𝐡𝐞 𝐏𝐮ｎｊａ𝐛, shares his visionary thoughts on the strategic collaboration with 𝐇ｕｎａ𝐫ｍａｎ𝐝 𝐏ｕｎｊａ𝐛. With a legacy of over a century in education, 𝐏ｕｎｊａｂ 𝐔ｎｉｖｅｒｓｉｔｙ is now partnering with us to bridge the gap between traditional learning and modern technological demands.

The importance of Artificial Intelligence (AI) and modern skills.
How 𝐇ｕｎａ𝐫ｍａｎ𝐝 𝐏ｕｎｊａ𝐛 is creating global opportunities for Pakistani youth.
Transitioning from "Education" to "Sustainable Livelihoods."
The role of technology in increasing Pakistan's foreign exchange.`,
    },
    {
      id: 5,
      title:
        "Hunarmand Punjab Brainathon Competition Winners Award Ceremony | Punjab Skill Development",
      videoUrl: "https://www.youtube.com/embed/ZtQAQGyUxkQ",
      fullDescription: `Hunarmand Punjab successfully organized the Brainathon Competition and awarded the winners in an official award ceremony held with the presence of distinguished dignitaries.

The ceremony was graced by Chief Guests including the Speaker Punjab Assembly Malik Ahmad Khan, and Education Minister Rana Sikandar Hayat.
This Brainathon Competition was conducted under the Skills Development and Youth Empowerment Program of Punjab, aimed at encouraging innovation, critical thinking, and problem-solving skills among the youth of Punjab.

The presence of senior leadership from the Punjab Government reflects strong support for skill-based education and innovation initiatives.
Hunarmand Punjab remains committed to empowering youth by providing platforms that promote talent, creativity, and professional growth.
This award ceremony highlights the vision of Hunarmand Punjab to build a skilled, competitive, and self-reliant generation for the future of Pakistan.`,
    },
    {
      id: 6,
      title:
        "Prof. Dr. Muhammad Ali (VC PU) | Strategic Partnership with Hunarmand Punjab for Youth Empowerment",
      videoUrl: "https://www.youtube.com/embed/spU3lJ_SqMk",
      fullDescription: `𝐄𝐦𝐩𝐨𝐰𝐞𝐫𝐢𝐧𝐠 𝐭𝐡𝐞 𝐲𝐨𝐮𝐭𝐡 𝐭𝐨𝐝𝐚𝐲 𝐟𝐨𝐫 𝐚 𝐝𝐢𝐠𝐢𝐭𝐚𝐥 𝐫𝐞𝐯𝐨𝐥𝐮𝐭ｉｏ𝐧 𝐭ｏ𝐦𝐨ｒｒｏ𝐰.

In this video, 𝐏ｒｏ𝐟. 𝐃ｒ. 𝐌ｕ𝐡ａｍｍａｄ 𝐀𝐥ｉ, the Vice Chancellor of 𝐏ｕｎｊａｂ 𝐔ｎｉｖｅｒｓｉｔｙ (𝐏𝐔), highlights the pivotal role of PU as the largest partner in the 𝐇ｕｎａ𝐫ｍａｎ𝐝 𝐏ｕｎｊａ𝐛 initiative.

𝐏ｕｎｊａｂ 𝐔ｎｉｖｅｒｓｉｔｙ is proud to facilitate the 𝐁𝐫ａｉｎ-𝐀-𝐓ｈοｎ examinations for over 13,000 students, ensuring a transparent and professional assessment process. This collaboration aims to provide free education and vocational training to 500,000 young individuals across Pakistan, including students from other provinces, fostering national unity and skill-based learning.

𝐏ｒｏｆ. 𝐃𝐫. 𝐌𝐮𝐡𝐚𝐦𝐦𝐚𝐝 𝐀𝐥𝐢 expresses his appreciation for the leadership of 𝐂𝐡𝐢𝐞𝐟 𝐌ａｒｙａｍ 𝐍ａｗａ𝐳 𝐒ｈａｒｉｆ, 𝐄ｄｕｃａ𝐭𝐢ｏｎ Ｍｉｎｉｓｔｅｒ 𝐑ａｎａ 𝐒ｉｋａｎ𝐝开𝐫 𝐇开𝐲ａ𝐭, and the entire 𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛 team for their dedication to building a 𝐃ｉ𝐠ｉ𝐭ａ𝐥 𝐏ａｋｉｓｔａｎ.

𝐒𝐩𝐞ａｋ𝐞ｒ: Prof. Dr. Muhammad Ali (VC, Punjab University)
𝐂ｏｌｌａｂｏｒａ𝐭𝐢𝐨ｎ: PU & Hunarmand Punjab Partnership
𝐆ｏａl: Training 500,000 youth in high-demand digital skills
𝐅𝐚𝐜𝐢𝐥𝐢𝐭𝐲: Free education and boarding for students nationwide`,
    },
    {
      id: 7,
      title:
        "Beyond Artificial Intelligence: The Rise of Artificial Life | Exclusive Session by Hunarmand Punjab",
      videoUrl: "https://www.youtube.com/embed/r01oaRfkQ1Y",
      fullDescription: `𝐓𝐡𝐞 𝐒𝐮λ𝐭𝐚𝐧 𝐨𝐟 𝐒𝐩ａｃｅ: 𝐁𝐫𝐢𝐝𝐠𝐢𝐧𝐠 𝐒ｕｒａｈ 𝐀𝐫-𝐑𝐚𝐡𝐦ａ𝐧 𝐰𝐢𝐭𝐡 𝐅ｕ𝐭ｕｒ𝐞 𝐑ο𝐛ο𝐭𝐢𝐜𝐬.

In an era of rapid digital transformation, 𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛 is proud to present a visionary discourse by 𝐖𝐚𝐣𝐚𝐡𝐚𝐭 𝐐𝐚𝐳𝐢 at the University of the Punjab. A pioneer in Artificial Intelligence since 1999, Mr. Qazi explores the intersection of high-end technology and theological wisdom, providing a definitive roadmap for the next two centuries.

As part of 𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛’ｓ mission to lead the province into the future, this session decodes the transition from automation to 𝐀𝐫𝐭𝐢ｆｉｃ𝐢ａｌ 𝐋𝐢ｆｅ.

𝐓𝐡𝐞 𝟐𝟎０-𝐘𝐞ａ𝐫 𝐒ｔｒａｔ𝐞ｇｉ𝐜 𝐕ｉ𝐬ｉｏ𝐧: Why AI is not a fleeting trend, but a calculated global trajectory mapped out until the year 𝟐𝟏𝟗𝟗.
𝐅ｒｏｍ 𝐀𝐈 𝐭ｏ 𝐀𝐫𝐭𝐢ｆ𝐢𝐜𝐢ａｌ 𝐋𝐢ｆｅ: A deep dive into the synthesis of DNA and the emergence of "Soft Robotics"—machines designed to grow and adapt like living organisms.
𝐓𝐞ｃｈｎｏｌｏ𝐠𝐢𝐜ａｌ 𝐒ｉｎｇｕｌａｒｉｔｙ: How the roadmaps established in 2005 accurately predicted the rise of the Metaverse, AR/VR, and the current Quantum shift.
𝐀 𝐃𝐢𝐯𝐢ｎ𝐞 𝐂ｈａｌｌｅｎｇ𝐞: An profound reflection on 𝐒ｕｒａｈ 𝐀𝐫-𝐑ａｈｍａｎ, analyzing the "Authority" (Sultan) required for humanity to transcend planetary boundaries and explore the cosmos.

𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛 is the Government of Punjab’s flagship initiative dedicated to empowering the youth with cutting-edge skills. By bridging the gap between traditional education and future-tech industries, we are preparing the next generation to lead the global technological revolution.

𝐖开𝐣开𝐡开𝐭 𝐐开𝐳𝐢 has spent over two decades at the forefront of AI research and Quantum Computing in Pakistan. His work serves as a vital bridge between current technological capabilities and the future of synthetic existence.`,
    },
    {
      id: 8,
      title:
        "Hunarmand Punjab Student Success Story | Laptop Winner Nimra Chaudhary | Brainathon Winner",
      videoUrl: "https://www.youtube.com/embed/Ckw7uIF5Jfw",
      fullDescription: `𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛 𝐒ｔｕ𝐝ｅｎｔ 𝐒ｕ𝐜ｃｅｓｓ 𝐒ｔ𝐨ｒｙ | 𝐋ａｐｔｏ𝐩 𝐖ｉｎｎｅｒ 𝐍𝐢ｍｒａ 𝐂ｈａｕ𝐝ｈａｒｙ | 𝐁ｒａｉｎａｔｈｏ𝐧 𝐖𝐢ｎｎｅｒ

Ｎｉｍｒａ 𝐂ｈａｕｄｈａｒｙ from Lahore, a proud Laptop Winner and student of 𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛, shares her real learning experience in this video.

She explains how the 𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛 𝐩ｒ𝐨𝐠ｒａｍ provides advanced-level practical training, focusing on hands-on practice, experimentation, and real-world skills rather than just theory.

Nimra Chaudhary also extends his heartfelt thanks to Ｍｒ. 𝐑ａｎａ 𝐒ｉｋａｎ𝐝开ｒ 𝐇开ｙａｔ for launching such a powerful initiative and appreciates the visionary leadership of 𝐂𝐡𝐢𝐞ｆ Ｍｉｎｉ𝐬ｔｅｒ Ｍａｒｙａ𝐦 Ｎａｗａ𝐳 for empowering the youth of Pakistan through skills-based education.

This program is playing a vital role in preparing young Pakistanis for the future of web development, digital skills, and modern technology.`,
    },
    {
      id: 9,
      title:
        "𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛 𝐒ｔｕｄｅｎｔ 𝐒ｕｃｃｅｓｓ 𝐒ｔ𝐨ｒｙ | 𝐋ａｐｔｏ𝐩 𝐖ｉｎｎｅｒ 𝐌ａｒｙａ𝐦 Ｍｕｎｉｒ | 𝐁ｒａｉｎａｔｈｏ𝐧 𝐖ｉｎｎｅｒ",
      videoUrl: "https://www.youtube.com/embed/AjUq1s8UrOY",
      fullDescription: `𝐌ａｒｒ𝐲ａｍ Ｍｕｎｅｅｒ 𝐟𝐫𝐨ｍ 𝐊ａｓｕｒ (𝐓𝐞𝐡𝐬𝐢𝐥 𝐏ａ𝐭𝐭ｏｋ𝐢) a proud Laptop Winner and student of 𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛, shares her real learning experience in this video.

She explains how the 𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛 𝐩ｒｏ𝐠ｒａｍ provides advanced-level practical training, focusing on hands-on practice, experimentation, and real-world skills rather than just theory.

𝐌ａｒｙａ𝐦 Ｍｕｎｉｒ also extends his heartfelt thanks to Ｍｒ. 𝐑ａｎａ 𝐒ｉｋ开ｎ𝐝开𝐫 𝐇开ｙ开𝐭 for launching such a powerful initiative and appreciates the visionary leadership of Chief Minister Maryam Nawaz for empowering the youth of Pakistan through skills-based education.

This program is playing a vital role in preparing young Pakistanis for the future of web development, digital skills, and modern technology.`,
    },
    {
      id: 10,
      title:
        "The Inspiring Success Story of Umer Ali | Brain-a-Thon Winner | Hunarmand Punjab.",
      videoUrl: "https://www.youtube.com/embed/9CrMxgtvSxQ",
      fullDescription: `At 𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛, we believe that talent knows no boundaries and determination knows no limits. Today, we are proud to share the incredible journey of 𝐔ｍｅｒ 𝐀ｌ𝐢 from 𝐑ａ𝐰ａｌ𝐩ｉｎｄｉ—a true testament to the power of resilience.

Despite facing unique physical challenges, 𝐔ｍｅｒ refused to let any obstacle define his future. Through hard work and the practical training provided by the 𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛 𝐩ｒ𝐨𝐠ｒａｍ, he competed against thousands and secured a prestigious position among the 𝐓ｏｐ 𝟏𝟎 𝐖𝐢ｎｎｅｒｓ 𝐨ｆ 𝐭ｈ e 𝐁𝐫ａｉｎ-ａ-𝐓ｈｏｎ 𝐂ｏｍ𝐩𝐞𝐭𝐢𝐭𝐢𝐨𝐧.

𝐔ｍｅｒ’ｓ success proves that when provided with the right tools and hands-on technical education, every youth in Pakistan can become a leader in the digital economy. In this video, he shares his learning experience and expresses his gratitude to 𝐂ｈｉｅｆ Ｍｉｎｉ𝐬ｔｅｒ Ｍａｒｙａ𝐦 Ｎａｗａ𝐳 𝐒ｈａ𝐫𝐢ｆ and Ｍｉｎｉｓ𝐭ｅｒ 𝐟ｏｒ 𝐒ｃｈｏｏｌ 𝐄ｄｕｃａｔｉｏｎ, 𝐑ａｎａ 𝐒ｉｋ开ｎ𝐝开𝐫 𝐇开开𝐭, for launching an initiative that empowers every citizen regardless of their circumstances.

𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛 is more than just a training program; it is a movement to ensure a skill-based, prosperous future for the youth of Pakistan.`,
    },
    {
      id: 11,
      title:
        "Hunarmand Punjab Student Success Story | Laptop Winner Akasha Arooj | Brainathon Winner",
      videoUrl: "https://www.youtube.com/embed/k7YNWq_995Q",
      fullDescription: `𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛 𝐒ｔｕｄｅｎｔ 𝐒ｕｃｃｅｓｓ 𝐒ｔｏｒｙ | 𝐋ａｐｔ𝐨𝐩 𝐖ｉｎｎｅｒ 𝐀𝐤ａｓｈａ 𝐀𝐫ｏｏ𝐣 | 𝐁ｒａｉｎａｔｈｏ𝐧 𝐖ｉｎｎｅｒ

𝐀ｋａｓ𝐡ａ 𝐀ｒｏｏ𝐣 from 𝐌ａｎｄ𝐢 𝐁ａｈａｕｄｄｉ𝐧, a proud Laptop Winner and student of 𝐇ｕｎａｒｍａｎ𝐝 𝐏ｕｎｊａ𝐛, shares her real learning experience in this video.

She explains how the 𝐇ｕｎａ𝐫ｍａｎ𝐝 𝐏ｕｎｊａ𝐛 𝐩ｒｏ𝐠ｒａｍ provides advanced-level practical training, focusing on hands-on practice, experimentation, and real-world skills rather than just theory.

𝐀ｋａｓ𝐡ａ 𝐀ｒｏｏ𝐣 also extends his heartfelt thanks to Ｍｒ. 𝐑ａｎａ 𝐒ｉｋ开ｎ𝐝开𝐫 𝐇开ｙ开𝐭 for launching such a powerful initiative and appreciates the visionary leadership of 𝐂𝐡ｉｅｆ Ｍｉｎｉｓ𝐭ｅｒ Ｍａｒｙａ𝐦 Ｎａｗａ𝐳 for empowering the youth of Pakistan through skills-based education.

This program is playing a vital role in preparing young Pakistanis for the future of web development, digital skills, and modern technology.`,
    },
    {
      id: 12,
      title:
        "Interview with Honorable Guest Prof. Dr. Yasir Ayaz | NCAI Pakistan | Inauguration Hunarmand Punjab",
      videoUrl: "https://www.youtube.com/embed/9dgJMrVYouo?si=EDkwLoZ5ictyxJnl",
      fullDescription: `Interview with Prof. Dr. Yasir Ayaz – Inauguration of Hunarmand Punjab
We had the honor of welcoming Prof. Dr. Yasir Ayaz, Chairman of National Center of Artificial Intelligence - NCAI Pakistan, at the inauguration of the Hunarmand Punjab.
Prof. Dr. Yasir Ayaz praised this visionary initiative for empowering youth with advanced IT skills and digital opportunities.
He highlighted the importance of such programs in shaping Pakistan’s future workforce for the global tech industry.
His appreciation motivates us to continue building a skilled and technologically empowered Pakistan.
`,
    },
    {
      id: 13,
      title:
        "Interview with Honorable Guest Dr. Wajahat Qazi | Comsats University | Inauguration Hunarmand Punjab",
      videoUrl:
        "https://www.youtube.com/embed/_3hRDF_FQqQ?si=0-0000000000000000",
      fullDescription: `Interview with Dr. Wajahat Qazi – Inauguration of Hunarmand Punjab
We were honored to host Dr. Wajahat Qazi from COMSATS University during the inauguration of Hunarmand Punjab.
Dr. Wajahat Qazi praised this groundbreaking initiative for providing youth with modern IT skills and career opportunities.
He emphasized how such programs are vital for building a digitally empowered Pakistan and strengthening the tech ecosystem.
His words of encouragement inspire us to continue our mission of youth empowerment through modern IT skills.`,
    },
    {
      id: 14,
      title:
        "Interview with Honorable Guest Dr. Yasir Niaz Khan | CTO PSCA | Inauguration Hunarmand Punjab",
      videoUrl:
        "https://www.youtube.com/embed/N5OYV3PkDXo?si=0-0000000000000000",
      fullDescription: `Interview with Dr. Yasir Niaz Khan – Inauguration of Hunarmand Punjab
We had the privilege of hosting Dr. Yasir Niaz Khan, Chief Technology Officer at Punjab Safe City Authority - PSCA, during the inauguration of the Hunarmand Punjab.
Dr. Yasir Niaz highly appreciated this initiative for creating opportunities in IT education, innovation, and digital transformation.
He emphasized the importance of such programs in preparing a skilled workforce for Pakistan’s future tech landscape.
His valuable insights and encouragement strengthen our commitment to building a digitally empowered youth.`,
    },
    {
      id: 15,
      title:
        "Interview with Honorable Guest Dr. Yasir Niaz Khan | CTO PSCA | Inauguration Hunarmand Punjab",
      videoUrl:
        "https://www.youtube.com/embed/N5OYV3PkDXo?si=0-0000000000000000",
      fullDescription: `Interview with Mubashir Hussain Chand – Hunarmand Punjab
We were honored to welcome Mubashir Hussain Chand, CEO of Hum Mashal E Rah Foundation, during the inauguration of Hunarmand Punjab initiative.
He praised this visionary program for empowering youth through free IT education, scholarships, and digital skill development.
Mubashir Hussain Chand highlighted the importance of Hunarmand Punjab Vision in creating a strong, skilled workforce for Pakistan’s future.
His appreciation motivates us to continue building opportunities for thousands of students across Punjab.
`,
    },
    {
      id: 16,
      title:
        "Laptop Winner Highlights | Minhal Raza From Sargodha | Inauguration Hunarmand Punjab",
      videoUrl:
        "https://www.youtube.com/embed/JWXBm9v2QyY?si=0-0000000000000000",
      fullDescription: `Laptop Winner Highlights – Minhal Raza from Sargodha
We proudly celebrate the success of Minhal Raza, a dedicated student from Sargodha, who received a laptop under the Hunarmand Punjab Scholarship Card Program.
Minhal Raza expressed heartfelt appreciation for this initiative, which is empowering students with digital tools for learning, freelancing, and IT skill development.
He highlighted how the Laptop Scheme is helping students achieve their academic and professional goals.
His success story inspires thousands of youth to join this mission and transform their future.
`,
    },
    {
      id: 17,
      title:
        "Laptop Winner Highlights | Abdul Rehman from Lahore | Inauguration Hunarmand Punjab",
      videoUrl:
        "https://www.youtube.com/embed/DgXT0twJJFI?si=0-0000000000000000",
      fullDescription: `Laptop Winner Student Review – Abdul Rehman from Lahore
We are proud to share the success story of Abdul Rehman from Lahore, who received a laptop under the Hunarmand Punjab Scholarship Card Program.
Abdul Rehman expressed deep gratitude for this remarkable initiative that provides students with digital resources and free IT education.
He acknowledged how the Laptop Scheme is bridging the digital gap and helping youth explore new opportunities in learning and freelancing.
His appreciation motivates us to continue empowering students across Punjab with technology and skills.
`,
    },
    //     {
    //       id: 6,
    //       title:
    //         "Hunarmand Punjab Scholarship Cards Are Now OPEN! (Only 50,000 Available)",
    //       videoUrl: "",
    //       shortDescription:
    //         "We are thrilled to announce that the distribution of Hunarmand Punjab Scholarship Cards has officially begun!",
    //       fullDescription: `🎉 Hunarmand Punjab Scholarship Cards Are Now OPEN!
    // We are thrilled to announce that the distribution of Hunarmand Punjab Scholarship Cards has officially begun! A total of 50,000 Scholarship Cards will be awarded to selected applicants across Pakistan. 25,000 Scholarship Cards are exclusively reserved for students from Punjab. The remaining 25,000 Cards will be distributed among students from other provinces. These cards grant access to completely free, advanced IT and digital skills training under the Hunarmand Punjab initiative. Don't miss your chance — Apply Now and be part of the digital transformation!`,
    //     },
  ];

  const handleReadMore = (news) => {
    setSelectedNews(news);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedNews(null);
    setPlayingVideoId(null); // Stops any playing video
  };

  return (
    <>
      <div className="breadcrums position-relative ">
        <ParticleBackground />
        <h2>News & Events</h2>
      </div>
      <div className="news pt-5 pb-5 text-center">
        <h2 className="mb-3">Latest News & Events</h2>
        <p>
          Stay up-to-date with all the latest developments at Hunarmand. From
          new course launches to special <br /> events, find out what's
          happening and how you can get involved in shaping the future of
          Hunarmand Punjab
          <br /> skilled workforce. Keep an eye on this space for exciting
          announcements and opportunities!
        </p>
        <div className="container">
          <div className="row justify-content-center px-4 pt-5">
            {newsData.map((news) => (
              <div key={news.id} className="col-lg-4 col-md-6 mb-4">
                <div className="course h-100 p-0">
                  <div className="course-card-details h-100 d-flex flex-column gap-2 justify-content-between align-items-start">
                    {/* Title First */}
                    <h6 className="mb-2 font-18 text-start">{news.title}</h6>

                    <div className="video-wrapper w-100">
                      <div className="vid-container">
                        <iframe
                          src={news.videoUrl}
                          title="YouTube video player"
                          frameBorder="0"
                          allow="autoplay; fullscreen; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>

                    {/* Category Badge */}
                    {/* <div
                      className="text-start d-flex align-items-center gap-2 text-success px-2 p-1 rounded-2 mb-3"
                      style={{
                        background: "rgb(25 135 84 / 24%)",
                        width: "fit-content",
                      }}
                    >
                      <div className="fa fa-list-alt text-success"></div>
                      {news.videoUrl ? "Video" : "Announcement"}
                    </div> */}

                    {/* <hr /> */}

                    {/* Read More Button */}
                    <button
                      className="btn-green-sq"
                      onClick={() => handleReadMore(news)}
                    >
                      Read More <i className="fas fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <NewsModal
        isOpen={isModalOpen}
        onClose={closeModal}
        content={selectedNews}
      />
    </>
  );
};

export default NewsEvents;
